import React, { useEffect, useRef } from 'react';

const testimonials = [
  {
    text: 'Exceptional hospitality and beautifully appointed rooms. The staff went above and beyond to make our stay truly memorable. Highly recommended for pilgrims visiting Mahakal.',
    author: 'Priya Sharma',
    city: 'Bhopal',
    stars: 5,
  },
  {
    text: 'Perfect location — so close to the railway station and the Mahakal Corridor. Spacious rooms, clean and very well maintained. Will definitely return on our next pilgrimage.',
    author: 'Rahul Mishra',
    city: 'Raipur',
    stars: 5,
  },
  {
    text: 'The family suite was perfect for our group of five. Comfortable beds, great AC, and the hot geyser was a lifesaver. The proximity to Mahakal Mandir made everything so convenient.',
    author: 'Anjali Verma',
    city: 'Nagpur',
    stars: 5,
  },
];

export default function Testimonials() {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    ref.current.style.opacity = '0';
    ref.current.style.transform = 'translateY(24px)';
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        e.target.style.transition = 'opacity .9s ease, transform .9s ease';
        e.target.style.opacity = '1';
        e.target.style.transform = 'none';
      }
    }, { threshold: 0.1 });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <>
      <style>{`
        .test-card { padding:2.2rem 2rem; position:relative;
          border-right:1px solid rgba(201,168,76,0.2); transition:background .3s; }
        .test-card:last-child { border-right:none; }
        .test-card:hover { background:rgba(201,168,76,0.04); }
        @media(max-width:860px){
          .test-grid { grid-template-columns:1fr !important; }
          .test-card { border-right:none !important; border-bottom:1px solid rgba(201,168,76,0.2) !important; }
          .test-card:last-child { border-bottom:none !important; }
        }
      `}</style>

      <section style={{ padding:'7rem 3rem', background:'#EDE0CC' }}>
        <div style={{ maxWidth:'1100px', margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom:'3rem' }}>
            <div style={{ display:'flex', alignItems:'center', gap:'.8rem', justifyContent:'center', marginBottom:'1rem' }}>
              <div style={{ width:'32px', height:'1px', background:'#C9A84C' }}/>
              <div style={{ width:'5px', height:'5px', background:'#C9A84C', transform:'rotate(45deg)' }}/>
              <div style={{ width:'32px', height:'1px', background:'#C9A84C' }}/>
            </div>
            <p style={{ fontFamily:"'Jost',sans-serif", fontSize:'.58rem', letterSpacing:'5px',
              textTransform:'uppercase', color:'#1B2F6E', marginBottom:'.7rem', fontWeight:400 }}>
              Guest Reviews
            </p>
            <h2 style={{ fontFamily:"'Cinzel',serif", fontSize:'clamp(1.9rem,4vw,2.9rem)',
              fontWeight:500, color:'#1B2F6E', marginBottom:'.2rem' }}>
              Voices of our Guests
            </h2>
            <h3 style={{ fontFamily:"'Cormorant',serif", fontSize:'clamp(1.2rem,2.5vw,1.8rem)',
              fontStyle:'italic', fontWeight:400, color:'#C9A84C' }}>
              Trusted by travellers &amp; pilgrims
            </h3>
          </div>

          <div ref={ref} className="test-grid"
            style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', border:'1px solid rgba(201,168,76,0.2)' }}>
            {testimonials.map((t, i) => (
              <div key={i} className="test-card">
                {/* Big quote */}
                <div style={{ fontFamily:"'Cormorant',serif", fontSize:'5.5rem',
                  color:'#C9A84C', opacity:.12, lineHeight:.8,
                  position:'absolute', top:'1rem', left:'1.5rem', userSelect:'none' }}>"</div>
                {/* Stars */}
                <div style={{ display:'flex', gap:'3px', marginBottom:'1.2rem' }}>
                  {[...Array(t.stars)].map((_,j) => (
                    <span key={j} style={{ color:'#C9A84C', fontSize:'.8rem' }}>★</span>
                  ))}
                </div>
                <p style={{ fontFamily:"'EB Garamond',serif", fontStyle:'italic',
                  fontSize:'1.05rem', lineHeight:1.85,
                  color:'rgba(42,31,14,0.7)', marginBottom:'1.5rem' }}>
                  "{t.text}"
                </p>
                <div style={{ display:'flex', alignItems:'center', gap:'.7rem' }}>
                  <div style={{ width:'28px', height:'1px', background:'#C9A84C' }}/>
                  <div>
                    <div style={{ fontFamily:"'Cinzel',serif", fontSize:'.72rem',
                      letterSpacing:'2px', color:'#1B2F6E', fontWeight:500 }}>{t.author}</div>
                    <div style={{ fontFamily:"'Jost',sans-serif", fontSize:'.55rem',
                      letterSpacing:'2px', textTransform:'uppercase',
                      color:'rgba(92,74,48,0.5)', marginTop:'2px' }}>{t.city}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
